import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconRatingVeryPoor(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M3 1H0v10h3V1Zm13.375 11.05c.894 0 1.625-.765 1.625-1.7l-.008-.068.008-.008V8.65c0-.221-.04-.425-.114-.62l-2.454-5.993A1.615 1.615 0 0 0 13.938 1H6.625C5.731 1 5 1.765 5 2.7v8.5c0 .468.179.893.48 1.199L10.825 18l.86-.892c.22-.23.358-.553.358-.902l-.024-.271-.772-3.885h5.127ZM15 13h-2v7h2v-7Zm8 7.15c.55 0 1-.495 1-1.1l-.005-.044L24 19v-1.05c0-.143-.025-.275-.07-.401l-1.51-3.878c-.15-.396-.505-.671-.92-.671H17c-.55 0-1 .495-1 1.1v5.5c0 .302.11.577.295.775L19.585 24l.53-.578a.871.871 0 0 0 .22-.582l-.015-.177-.475-2.513H23Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
